// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RanaDirectory } from "./RanaDirectory";
import {
  RanaDirectoryFromJSON,
  RanaDirectoryFromJSONTyped,
  RanaDirectoryToJSON,
  RanaDirectoryToJSONTyped,
} from "./RanaDirectory";

/**
 *
 * @export
 * @interface CreateBasicHydroDataOutput
 */
export interface CreateBasicHydroDataOutput {
  /**
   *
   */
  outputDirectory: RanaDirectory;
}

/**
 * Check if a given object implements the CreateBasicHydroDataOutput interface.
 */
export function instanceOfCreateBasicHydroDataOutput(
  value: object
): value is CreateBasicHydroDataOutput {
  if (
    (!("outputDirectory" in (value as Record<string, any>)) &&
      !("output_directory" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["outputDirectory"] === undefined &&
      (value as Record<string, any>)["output_directory"] === undefined)
  )
    return false;
  return true;
}

export function CreateBasicHydroDataOutputFromJSON(json: any): CreateBasicHydroDataOutput {
  return CreateBasicHydroDataOutputFromJSONTyped(json, false);
}

export function CreateBasicHydroDataOutputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateBasicHydroDataOutput {
  if (json == null) {
    return json;
  }
  return {
    outputDirectory: RanaDirectoryFromJSON(json["output_directory"]),
  };
}

export function CreateBasicHydroDataOutputToJSON(json: any): CreateBasicHydroDataOutput {
  return CreateBasicHydroDataOutputToJSONTyped(json, false);
}

export function CreateBasicHydroDataOutputToJSONTyped(
  value?: CreateBasicHydroDataOutput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    output_directory: RanaDirectoryToJSON(value["outputDirectory"]),
  };
}
